export default __webpack_public_path__ + "static/media/11r.84eca683.svg";